import styled from "styled-components";

export default function PontosTuristicos(){
    return(
        <Content>
            <Header>
                <h1>Pontos Turísticos</h1>
                <span>Rio de Janeiro • RJ</span>
            </Header>

            <Section>
                <h2>Praia de Ipanema</h2>
                
                <p>
                    Uma das praias mais famosas do mundo, conhecida por sua beleza natural, águas claras, areia branca e vista do Morro Dois Irmãos.
                </p>
            </Section>

            <Section>
                <h2>Pedra do Arpoador</h2>
                <p>
                    Ponto clássico para assistir ao pôr do sol, localizado na divisa entre Ipanema e Copacabana, muito procurado por surfistas e turistas.
                </p>
            </Section>

            <Section>
                <h2>Posto 8</h2>
                <p>
                    Trecho tradicional da praia, próximo à Pedra do Arpoador, conhecido pelo clima jovem e esportivo.
                </p>
            </Section>

            <Section>
                <h2>Posto 9</h2>
                <p>
                    Um dos pontos mais icônicos de Ipanema, associado à diversidade cultural, liberdade de expressão e encontros ao ar livre.
                </p>
            </Section>

            <Section>
                <h2>Feira Hippie de Ipanema</h2>
                <p>
                    Realizada aos domingos na Praça General Osório, reúne artesanato, arte, moda, música e gastronomia típica brasileira.
                </p>
            </Section>

            <Section>
                <h2>Praça General Osório</h2>
                <p>
                    Importante espaço urbano do bairro, cercado por bares, cafés e comércio, além de sediar eventos culturais.
                </p>
            </Section>

            <Section>
                <h2>Canal de Ipanema (Canal da Rua Visconde de Pirajá)</h2>
                <p>
                    Área que conecta a Lagoa Rodrigo de Freitas ao mar, bastante frequentada para caminhadas e lazer.
                </p>
            </Section>

            <Section>
                <h2>Orla de Ipanema</h2>
                <p>
                    O calçadão com desenho em ondas, ciclovia e quiosques, ideal para caminhadas, esportes e convivência social.
                </p>
            </Section>
        </Content>
    )
}

const Content = styled.div`
  max-width: 900px;
  margin: 20px auto;
  padding: 24px;
  box-sizing: border-box;

  font-family: "Poppins", sans-serif;
  color: #333;

  background-color: #f0f8ffc7;
  border-radius: 20px;

  @media (max-width: 768px) {
    padding: 20px;
    margin: 16px;
  }

  @media (max-width: 480px) {
    padding: 16px;
    margin: 12px;
    border-radius: 16px;
  }
`;


const Header = styled.header`
  text-align: center;
  margin-bottom: 24px;

  h1 {
    font-size: 2.5rem;
    margin-bottom: 8px;
    font-weight: bold;
  }

  span {
    font-size: 1rem;
    color: #777;
  }

  @media (max-width: 768px) {
    h1 {
      font-size: 2.1rem;
    }
  }

  @media (max-width: 480px) {
    h1 {
      font-size: 1.8rem;
    }

    span {
      font-size: 0.9rem;
    }
  }
`;


const Section = styled.section`
  margin-bottom: 24px;

  h2 {
    font-size: 1.6rem;
    margin-bottom: 12px;
    color: #0a6cff;
    font-weight: bold;
  }

  p {
    line-height: 1.7;
    margin: 10px 0;
    font-size: 1rem;
  }

  li {
    line-height: 1.7;
    margin: 10px 0;
  }

  span {
    font-weight: bold;
  }

  @media (max-width: 768px) {
    h2 {
      font-size: 1.4rem;
    }

    p,
    li {
      font-size: 0.95rem;
    }
  }

  @media (max-width: 480px) {
    h2 {
      font-size: 1.25rem;
    }

    p,
    li {
      font-size: 0.9rem;
      line-height: 1.6;
    }
  }
`;

